import InfoAlert from './InfoAlert.tsx';

export default InfoAlert;
